export default {
  drawerTitle: 'Sincronización',
  drawerClose: 'Cerrar',
  taskPhotoDeleteNeedsConnection: 'El borrado de fotos de tareas requiere conexión a internet.',
  taskPhotoNotSyncedYet: 'Esta foto aún no se ha sincronizado; podrás borrarla cuando suba.',
  taskPhotoEditNeedsConnection: 'Editar una foto de tarea requiere conexión a internet.',
  taskPhotoEditNotSyncedYet: 'Esta foto aún no se ha sincronizado; podrás editarla cuando suba.',
  taskPhotoEditFailed: 'No se pudo guardar la edición de la foto. Inténtalo de nuevo.',
  taskPhotoSyncing: 'Sincronizando la foto…',
  taskPhotoBusy: 'Espera a que termine la operación con la foto anterior.',
  taskPhotoDeleteFailed: 'No se pudo eliminar la foto. Inténtalo de nuevo.',
  taskPhotoEditOldNotRemoved: 'Se guardó la foto editada, pero la anterior no se pudo eliminar. Bórrala manualmente.',
  allSynced: 'Todo sincronizado',
  onePending: '1 cambio pendiente',
  pendingChanges: '{count} cambios pendientes',
  syncing: 'Sincronizando…',
  failedCount: '{count} con error',
  reauthNeeded: 'Reingresa para sincronizar tus cambios pendientes',
  pendingSection: 'Pendientes',
  failedSection: 'Con error',
  retry: 'Reintentar',
  discard: 'Descartar',
  empty: 'No hay nada pendiente',
  syncNow: 'Sincronizar ahora',
  statusQueued: 'En cola',
  statusSyncing: 'Sincronizando',
  statusSynced: 'Sincronizado',
  statusFailed: 'Error',
  occurrenceFinished: 'Formulario finalizado correctamente.',
  occurrenceFinishedOffline: 'Formulario finalizado sin conexión. Se enviará automáticamente al reconectar.',
  occurrenceFinishError: 'No se pudo finalizar la auditoría. Tus respuestas y fotos siguen guardadas: conéctate y reintenta o avisa a soporte.',
  occurrenceFinishDeferred: 'Auditoría finalizada. Tu trabajo está guardado y se enviará solo cuando vuelva la conexión.',
  deferredCloseHint: 'Sin conexión: al finalizar, la auditoría se guarda y se envía sola cuando vuelva la señal.',
  deferredClosePending: 'Esta auditoría ya se finalizó y está guardada en el equipo. Se enviará sola cuando vuelva la conexión.',
  occurrenceSyncingBeforeDocument: 'Terminando de sincronizar la auditoría antes de enviarla...',
  occurrencePendingForDocument:
    'La auditoría todavía se está sincronizando. Espera a que termine e inténtalo de nuevo para no enviar un PDF incompleto.',
  occurrenceNotClosedTitle: 'La auditoría aún no está finalizada',
  occurrenceNotClosedMessage:
    'Esta auditoría todavía no está finalizada. Si la envías ahora, al destinatario le llegará el PDF con la ' +
    'leyenda "Sin Finalizar" y con la calificación de avance actual (puede cambiar al finalizar). Si ya terminaste de contestarla, presiona FINALIZAR primero; ' +
    'si acabas de finalizarla, espera unos segundos a que termine de sincronizar.',
  occurrenceNotClosedOk: 'Enviar de todas formas',
  occurrenceNotClosedCancel: 'Esperar',
  occurrenceLoadError: 'No se pudo cargar la auditoría. Verifica tu conexión e inténtalo de nuevo.',
  taskAutoCreateFailed: 'No se pudo crear la tarea automática. Inténtalo de nuevo.',
  // Fotos que NO llegaron al servidor (anti pérdida-silenciosa)
  photoSection: 'Fotos sin subir',
  photoIssuesCount: '{count} foto(s) sin subir',
  photoMissing: 'Foto no recuperable (no llegó al servidor)',
  photoCaptureFailed: 'No se pudo guardar la foto — vuelve a tomarla',
  photoOrphan: 'Foto sin adjuntar — vuelve a tomarla',
  photoRef: 'Referencia: {ref}',
  photoAck: 'Entendido',
  actionError: 'No se pudo completar la acción. Inténtalo de nuevo.',
  answersNotSent: 'Hay {n} respuesta(s) de este formulario que no se pudieron enviar al servidor. ' +
    'Se conservan en el dispositivo: revisa la sección "Con error" del panel de sincronización para reintentar.',
  saveAnswerFailed: 'No se pudo guardar la respuesta sin conexión. Inténtalo de nuevo.',
  photoSaveFailed: 'No se pudo guardar la foto sin conexión. Inténtalo de nuevo.',
  videoSaveFailed: 'No se pudo guardar el video sin conexión. Inténtalo de nuevo.',
  photoNotDownloaded: 'Esta foto no está descargada en el dispositivo',
  photoNotDownloadedHint: 'Conéctate a internet para verla y editarla. Tu trabajo offline no se pierde.',
  photoLoadFailed: 'No se pudo cargar la imagen',
  photoLoadFailedHint: 'Vuelve a intentarlo. Si sigue fallando, la foto podría estar dañada.',
  photoRetry: 'Reintentar',
  resyncingComments: 'Re-sincronizando comentarios...',
  shareDiagnostic: 'Compartir diagnóstico',
  qaModeOn: 'Modo diagnóstico ACTIVADO — usa el icono del bicho para compartir el reporte',
  qaModeOff: 'Modo diagnóstico desactivado'
}
